module.exports = __webpack_public_path__ + "static/media/exclamacionSymbology.864b1812.svg";